import Badge from './badge-TEMPLATE_VERSION'

export default Badge
